export function verifyPasswordRequirements(password: string): boolean {
    

    if (password.length < 7) {
        return false;
    }


    const hasUppercase = /[A-Z]/.test(password);
    if (!hasUppercase) {
        return false;
    }


    const hasLowercase = /[a-z]/.test(password);
    if (!hasLowercase) {
        return false;
    }


    const hasNumber = /\d/.test(password);
    if (!hasNumber) {
        return false;
    }

    return true;
}
